import { render, staticRenderFns } from "./AccountsViewTabIncomes.vue?vue&type=template&id=897c9376"
import script from "./AccountsViewTabIncomes.vue?vue&type=script&lang=js"
export * from "./AccountsViewTabIncomes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports